import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import CardProjectFicheHrs2 from "./CardProjectFicheHrs2";


const SecondaryDetailCard = ({
    hrsTotalExtraResource,
    budgetHrsPlanning,
    budgetHrsDevelopment,
    budgetHrsTesting = 0,
    budgetHrsTotal,
    hrsTotalByClickup,
    hrsTotalExtraTime,
    hrsTotal,
}) => {
    return (
        <>
            <CardProjectFicheHrs2
                title="Horas recursos extras"
                className="text-[#686868] bg-white"
                hrs={hrsTotalExtraResource}
                icon={iconsDetailsProyect.recursosextras}
            />
            <CardProjectFicheHrs2
                title="Hrs Presupuesto Planeación"
                className="bg-[#fff]"
                hrs={budgetHrsPlanning}
                icon={iconsDetailsProyect.horasConsumidas}
            />
            <CardProjectFicheHrs2
                title="Horas trabajadas"
                className="text-[#686868] bg-white"
                hrs={hrsTotalByClickup}
                icon={iconsDetailsProyect.trabajadas}
            />
            <CardProjectFicheHrs2
                title="Hrs Presupuesto Desarrollo"
                className="bg-white"
                hrs={budgetHrsDevelopment}
                icon={iconsDetailsProyect.presupuestoDesarrollo}
            />
            <CardProjectFicheHrs2
                title="Horas extras trabajadas"
                className="text-[#686868] bg-white"
                hrs={hrsTotalExtraTime}
                icon={iconsDetailsProyect.extrasTrabajadas}
            />
            <CardProjectFicheHrs2
                title="Hrs Presupuesto Testing"
                className="bg-white"
                hrs={budgetHrsTesting}
                icon={iconsDetailsProyect.presupuestoTesting}
            />
            <CardProjectFicheHrs2 title="Total horas consumidas" className="bg-[#FFC300]" hrs={hrsTotal} icon={iconsDetailsProyect.horasConsumidas} />
            <CardProjectFicheHrs2
                title="Total horas de presupuesto"
                className="bg-[#FF7915] text-white"
                hrs={budgetHrsTotal}
                icon={iconsDetailsProyect.horasPresupuesto}
            />
        </>
    );
};

export default SecondaryDetailCard;
